import EmailHighlighting from './email_highlighting';
export default EmailHighlighting;
